import './css/styles.scss';

function flytandeKortInit() {}

flytandeKortInit();
